import { render, staticRenderFns } from "./CancelledOrder.vue?vue&type=template&id=42481d20&scoped=true"
import script from "./CancelledOrder.vue?vue&type=script&lang=js"
export * from "./CancelledOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42481d20",
  null
  
)

export default component.exports